import {
  FirestoreError,
  doc,
  getDoc,
  onSnapshot,
  setDoc,
} from "firebase/firestore";
import { StoredPermissions } from "../@types/permissions";
import { defaultPermissions } from "../_constants/permissions";
import { db } from "./firebase";
import { get } from "http";

export const subscribeToUserPermissions = (
  adminUid: string,
  onPermissionsUpdate: (permissions: StoredPermissions) => void,
  onError: (error: FirestoreError) => void
) => {
  const userDocRef = doc(db, "users", adminUid, "metadata", "permissions");
  const unsubscribe = onSnapshot(
    userDocRef,
    (docSnap) => {
      if (docSnap.exists()) {
        const permissions = docSnap.data().all as StoredPermissions;
        onPermissionsUpdate(permissions);
      } else {
        onPermissionsUpdate(defaultPermissions);
      }
    },
    onError
  );

  return unsubscribe;
};

export const getPermissions = async (adminUid: string) => {
  const userDocRef = doc(db, "users", adminUid, "metadata", "permissions");
  const docSnap = await getDoc(userDocRef);
  if (docSnap.exists()) {
    return docSnap.data().all as StoredPermissions;
  }
  return defaultPermissions;
};

export const updatePermissions = async (
  adminUid: string,
  permissions: StoredPermissions
) => {
  const userDocRef = doc(db, "users", adminUid, "metadata", "permissions");
  await setDoc(userDocRef, { all: permissions });
  return permissions;
};
